import BookingsResource from "./bookings.resource";

const bookingsModule = angular
  .module("app.resources.bookings", [])
  .service("Bookings", BookingsResource);

export default bookingsModule;



// WEBPACK FOOTER //
// ./src/resources/bookings/bookings.module.js